export default __webpack_public_path__ + "static/support-sponsor-mrrfund-9e54cd31c689159994d3185bd176ef64.png";